import { useSermonSupport, SUPPORT_TAB_LABELS, SupportTabKey } from './common/useSermonSupport';

type Props = {
  workspace: ReturnType<typeof useSermonSupport>;
};

const TAB_KEYS: SupportTabKey[] = ['summary', 'qt', 'groupShare', 'praise'];

export default function SermonSupportResult({ workspace }: Props) {
  const {
    result, activeTab, handleTabChange,
    isEditing, draftText, setDraftText,
    copyFeedback, resultCardRef,
    handleStartEdit, handleSaveEdit, handleCancelEdit,
    handleCopy, handleWordDownload, handleImageSave,
  } = workspace;

  return (
    <aside className="card">
      <div className="section-title">
        <div>
          <h2>설교지원 결과</h2>
          <p>생성이 완료되면 탭을 눌러 각 자료를 확인하세요.</p>
        </div>
      </div>

      <div className="preview-header">
        {TAB_KEYS.map((tab) => (
          <button
            type="button"
            key={tab}
            className={`tab${activeTab === tab ? ' active' : ''}`}
            onClick={() => handleTabChange(tab)}
          >
            {SUPPORT_TAB_LABELS[tab]}
          </button>
        ))}
      </div>

      {!result ? (
        <div className="result-card result-empty">
          <p>왼쪽에서 설교 원문을 업로드하거나 붙여넣은 뒤 'AI 자료 생성하기'를 눌러주세요.</p>
        </div>
      ) : activeTab === 'praise' ? (
        <>
          {result.praiseThemes.length === 0 ? (
            <div className="result-card result-empty">
              <p>설교 본문에서 어울리는 찬양 주제를 찾지 못했습니다.</p>
            </div>
          ) : (
            <>
              <div className="praise-recommend-themes">
                {result.praiseThemes.map((theme) => (
                  <span className="praise-recommend-theme-chip" key={theme}>{theme}</span>
                ))}
              </div>

              {result.praiseSongs.length === 0 ? (
                <div className="result-card result-empty">
                  <p>매칭된 주제에 해당하는 찬양을 찾지 못했습니다.</p>
                </div>
              ) : (
                <div className="praise-recommend-song-list">
                  {result.praiseSongs.map((song) => (
                    <div className="praise-recommend-song-card" key={song.id}>
                      <div className="praise-recommend-song-info">
                        <span className="praise-recommend-song-title">{song.title}</span>
                        <span className="praise-recommend-song-meta">{song.stateSort} · {song.keySort} · {song.tempoSort}</span>
                      </div>
                      <button
                        type="button"
                        className="action-btn"
                        onClick={() => window.open(`/aiservice/worship/detail?id=${song.id}`, '_blank')}
                      >
                        자세히보기
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </>
          )}
        </>
      ) : (
        <>
          <div className="result-actions">
            {isEditing ? (
              <>
                <button type="button" className="action-btn primary" onClick={handleSaveEdit}>💾 저장</button>
                <button type="button" className="action-btn" onClick={handleCancelEdit}>✕ 취소</button>
              </>
            ) : (
              <>
                <button type="button" className="action-btn" onClick={handleStartEdit}>✏️ 수정</button>
                <button type="button" className="action-btn" onClick={handleCopy}>
                  {copyFeedback ? '✅ 복사됨' : '📋 복사'}
                </button>
                <button type="button" className="action-btn" onClick={handleWordDownload}>📄 워드 다운로드</button>
                <button type="button" className="action-btn" onClick={handleImageSave}>🖼 이미지 저장</button>
              </>
            )}
          </div>

          <div className="preview-body">
            {isEditing ? (
              <div className="result-card">
                <h3>{SUPPORT_TAB_LABELS[activeTab]} 수정</h3>
                <textarea
                  className="sermon-input result-edit-input"
                  value={draftText}
                  onChange={(e) => setDraftText(e.target.value)}
                  rows={12}
                />
              </div>
            ) : (
              <div className="result-card" ref={resultCardRef}>
                <h3>{SUPPORT_TAB_LABELS[activeTab]}</h3>
                <p className="result-text">{result[activeTab]}</p>
              </div>
            )}
          </div>
        </>
      )}
    </aside>
  );
}
